import { useCallback, useEffect, useRef, useState } from 'react';

export const useFullscreen = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const fullscreenRef = useRef<HTMLDivElement>(null);

    const toggleFullscreen = useCallback(() => {
        if (!document.fullscreenElement) {
            if (fullscreenRef.current?.requestFullscreen) {
                fullscreenRef.current.requestFullscreen();
            }
        } else {
            document.exitFullscreen();
        }
    }, []);

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        // const _handleKeyPress = (event: KeyboardEvent) => {
        //   if (event.key === 'f' || event.key === 'F') {
        //     event.preventDefault();
        //     toggleFullscreen();
        //   }
        // };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        // document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener(
                'fullscreenchange',
                handleFullscreenChange,
            );
            // document.removeEventListener('keydown', handleKeyPress);
        };
    }, [toggleFullscreen]);

    return {
        isFullscreen,
        toggleFullscreen,
        fullscreenRef,
    };
};
